import { render, staticRenderFns } from "./reserva.vue?vue&type=template&id=02527a84&"
import script from "./reserva.vue?vue&type=script&lang=js&"
export * from "./reserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports